import { TActions } from '../../../AppModulesWrapper';

import {
  CHECK_SERVICE_START,
  CHECK_SERVICE_SUCCESS,
  CHECK_SERVICE_FAIL,
  CHANGE_AUTO_PROLONG,
} from '../../actions/checkoutInfo';
import { LOAD_PUBLISH_TERMS_SUCCESS } from '../../actions/publishTerms';
import { RESET_STATE } from '../../actions/resetState';
import { ICheckoutInfoState, ECheckServiceStatus } from '../../types/reducers/checkoutInfo';
import { defaultState, defaultAutoProlongInfo } from './defaultState';

export function checkoutInfo(state: ICheckoutInfoState = defaultState, action: TActions): ICheckoutInfoState {
  switch (action.type) {
    case LOAD_PUBLISH_TERMS_SUCCESS: {
      return {
        ...state,
        autoProlongInfo: {
          ...state.autoProlongInfo,
          isChecked: action.payload.publishTerms.autoProlong,
        },
      };
    }

    case CHECK_SERVICE_START: {
      return {
        ...state,
        status: ECheckServiceStatus.pending,
        errorCode: null,
      };
    }

    case CHECK_SERVICE_SUCCESS: {
      const { autoProlongInfo, ...checkoutInfo } = action.payload;

      return {
        ...state,
        ...checkoutInfo,
        status: ECheckServiceStatus.success,
        autoProlongInfo: {
          ...autoProlongInfo,
          isChecked: state.autoProlongInfo.isChecked,
        },
      };
    }

    case CHECK_SERVICE_FAIL: {
      return {
        ...defaultState,
        status: ECheckServiceStatus.fail,
        errorCode: action.payload,
        autoProlongInfo: {
          ...defaultAutoProlongInfo,
          isChecked: state.autoProlongInfo.isChecked,
        },
      };
    }

    case CHANGE_AUTO_PROLONG: {
      return {
        ...state,
        autoProlongInfo: {
          ...state.autoProlongInfo,
          isChecked: action.payload,
        },
      };
    }

    case RESET_STATE:
      return {
        ...defaultState,
      };

    default:
      return state;
  }
}
